import React, { Fragment } from 'react';

interface Props {
	title: string;
	icon?: 'fa-exclamation-triangle';
}

export const ErrorMessage = (props: Props) => {
	return (
		<Fragment>
			<h4 style={{ margin: '10px' }} className='text-center'>
				{props.title} <i className={`fa ${props.icon}`}></i>
			</h4>
		</Fragment>
	);
};
